import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
    } catch {
      setUser(false);
      setTenant(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const applyAuth = (data) => {
    if (data.token) localStorage.setItem("asd_token", data.token);
    setUser(data.user);
    setTenant(data.tenant);
  };

  const login = async (email, pin) => {
    const { data } = await api.post("/auth/login", { email, pin });
    applyAuth(data);
    return data;
  };

  const registerAsd = async (payload) => {
    const { data } = await api.post("/auth/register-asd", payload);
    applyAuth(data);
    return data;
  };

  const loginGoogle = async (sessionId) => {
    const { data } = await api.post("/auth/google", {}, { headers: { "X-Session-ID": sessionId } });
    applyAuth(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("asd_token");
    setUser(false);
    setTenant(null);
  };

  const can = (mod, level = "view") => {
    if (!user) return false;
    const p = (user.permissions_effective || {})[mod] || "none";
    return level === "view" ? p === "view" || p === "edit" : p === "edit";
  };

  return (
    <AuthCtx.Provider value={{ user, tenant, loading, login, registerAsd, loginGoogle, logout, can, refresh, setTenant }}>
      {children}
    </AuthCtx.Provider>
  );
}
